import gql from 'graphql-tag';

export const FULL_PLEX_INPUT_ERROR_FRAGMENT = gql`
  fragment fullPlexInputError on PlexInputError {
    __typename
    addedMembers {
      __typename
      type
      id
      message
    }
  }
`;
